import Card from 'app/shared-components/Card'
import SkyNetTable from 'app/shared-components/SkyNetTable'
import useCardForTableStyles from 'app/tss/cardForTable'
import useTableStyles from 'app/tss/table.styles'

import requestConfig from 'app/requests/ServiceCenter/ServiceCenter.requests'
import tableConfig from './outboundOrder.config'

const OutboundOrder = ({
    serviceCenterId,
}: { serviceCenterId: number }) => {
    const {
        classes: cardClasses,
    } = useCardForTableStyles()
    const {
        classes: tableClasses,
    } = useTableStyles()

    return (
        <Card
            className={cardClasses.root}
            title="Outbound Orders"
        >
            <SkyNetTable
                name="OutboundOrder"
                tableConfig={tableConfig}
                customUrl={requestConfig.outboundOrders({
                    serviceCenterId,
                }).url}
                simple
                className={tableClasses.table}
            />
        </Card>
    )
}

export default OutboundOrder
